import styled from 'styled-components'

export const ShareMemberWrapper = styled.div`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.background.secondary.B};
    border-radius: ${({ theme }) => theme.radii.large};
  }
`
